<template>
   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :class="classes" x="0px" y="0px" preserveAspectRatio="xMidYMid slice" :viewBox="viewBox">
        <path class="path svg-animate" :style="'stroke-width:' + strokeWidth" fill-rule="evenodd" clip-rule="evenodd" fill="none" :d="path"></path>
    </svg>
</template>

<script>
/**
 * svg描边动画组件
 * @vuedoc
 * @exports base/draw-svg-path
 */
// 组件class前缀
const prefixCls = 'wt-draw-svg-path'

export default {
  name: 'wt-draw-svg-path',
  props: {
    /**
      * svg path
      */
    path: {
      type: String,
      default: `M43.4,0.2c1.4,1.5,0.9,4,0.2,5.8c2-0.5,3.3-0.7,4.1-2.4
        c0.1,0.2,0.2,0.3,0.2,0.5c0.8,1.3-0.3,3.5,0.7,3.8c1.6,0.6,3.2,1.1,4.8,1.7c3.8-3.3,15.2-6,20.6-2.4c1.3,4.4,2.1,11.5,0.7,16.8
        c-0.6,1.6-1.3,3.2-1.9,4.8c-0.5,3,3.1,8.9,2.2,13.9c-1.4,7.4-6.1,11.1-8.9,15.8c5.3,1,9.1-3.1,16.3-1.7c10.3,2,18.4,13.5,10.6,24
        c-2.2,2.9-8.2,6.5-13.9,5.5c-3.1-0.5-7.2-1.5-10.6-0.7c-6.5,1.6-10.9,7.3-16.8,9.8c-1.9,0.8-7,1.4-9.1,0.2c-0.8-0.4-0.4-1.4-1.7-1.4
        c-1-0.1-6.3-0.3-7.2,0c-1.9,0.6-3.2,2.7-7.4,1.9c-7.7-1.5-12.8-11.4-12.7-20.9c-1,0.7-2.5,2-4.3,1.2c-0.4-0.2-0.8-0.5-1.2-0.7
        c-0.8-2.6,1.9-11,1.9-11c1.3-2.8,4.5-4.2,6.5-6.5c-0.2-0.2-0.5-0.3-0.7-0.5c-8.1-4-17.5-6.2-15.1-20.4c0.6-3,1.3-5.9,1.9-8.9
        C1.9,24.5-3.1,10.1,2.4,6.7c4.8-4.3,16.8,0.9,19.9,2.9c2.1-0.6,4.2-1.3,6.2-1.9c1.5-0.8,2.7-2.6,4.6-3.4C37.7,2.5,41.6,4.7,43.4,0.2
        z`
      // default:`M390.21952 631.09248c-61.26464 34.01984-70.35136-19.09888-70.35136-19.09888l-76.78208-178.46656c-29.54368-84.80512 25.56928-38.23744 25.56928-38.23744s47.2896 35.63392 83.17952 57.34784c35.87072 21.71392 76.75776 6.3744 76.75776 6.3744l501.9648-230.7776C837.94688 113.4528 684.96256 38.4 511.76576 38.4 229.11104 38.4 0 238.13248 0 484.52864c0 141.72544 75.8656 267.8656 194.0352 349.62176l-21.31072 122.01856c0 0-10.38848 35.6224 25.61536 19.10016 24.53376-11.26528 87.0784-51.63392 124.30976-76.20224 58.53056 20.31616 122.2976 31.5968 189.14432 31.5968 282.63168 0 511.79008-199.73248 511.79008-446.13376 0-71.36896-19.31008-138.76864-53.51552-198.59456C810.14144 381.7792 438.15808 604.51712 390.21952 631.09248L390.21952 631.09248 390.21952 631.09248zM390.21952 631.09248`
    },
    // 线条粗细
    strokeWidth: {
      type: [Number, String],
      default: 1
    },
    // svg原生属性，指定可视区域宽度
    viewBox: {
      type: String,
      default: '0 0 100 100'
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
/* 组件库组件禁止使用module */
.wt-draw-svg-path{
    .svg-animate{
        stroke:currentColor;
        animation: draw 3s ease-out infinite;
    }
    @keyframes draw {
        0% {
            stroke-dasharray: 0, 378;
        }
        50% {
            stroke-dasharray:378, 378;
            fill: rgba(0, 0, 0, 0);
            opacity: 1;
        }
        100% {
            stroke-dasharray: 378, 378;
            fill:currentColor;
            opacity: 0;
        }
    }
}
</style>
